export default __webpack_public_path__ + "static/media/commercial5.c28f3eb5.PNG";